/**
 * Which of the two calendar sidebar links is the current page (OPS-NAV1).
 *
 * Kalender and Rapporte are the same ROUTE — `/admin/calendar` — told
 * apart only by `?mode=reports`. React Router matches `NavLink` on the
 * path and ignores the query, so both links would report themselves as
 * active at once and the navigation would claim the user is in two
 * places. This decides between them.
 *
 * The fallback is not re-implemented here: `normalizeCalendarMode` is
 * the calendar's own, so an unknown `?mode=banana` lands on "all" for
 * the sidebar exactly as it does for the page. Two copies of that rule
 * is how a sidebar ends up highlighting a tab the page is not showing.
 */
import { normalizeCalendarMode } from "../../pages/admin/calendar/CalendarModeTabs";

export const CALENDAR_PATH = "/admin/calendar";
export const REPORTS_TO = `${CALENDAR_PATH}?mode=reports`;

/**
 * @param {string} pathname current location pathname
 * @param {string} search   current location search, with or without "?"
 * @returns {{calendar: boolean, reports: boolean}} at most one is true
 */
export function calendarNavState(pathname, search) {
  // Only ever active ON the calendar. A detail route beneath it would
  // need its own decision, and there is none today.
  if (pathname !== CALENDAR_PATH) {
    return { calendar: false, reports: false };
  }
  const mode = normalizeCalendarMode(new URLSearchParams(search).get("mode"));
  const reports = mode === "reports";
  // Exactly one, always — "all" and "tasks" both belong to Kalender.
  return { calendar: !reports, reports };
}
